/**
 * The painted text selection.
 *
 * One group at 0.35 with opaque children, so that if two bands ever do overlap the seam
 * composites ONCE instead of stacking 0.35 over 0.35 to ~0.58 and drawing a dark stripe.
 * Rows tile exactly now (`applyPerLineLeadingToFlow`), but a deliberately tight leading
 * is still allowed to overlap — `MIN_LEADING_FRACTION_OF_NATURAL` documents itself as a
 * damage bound and NOT a no-overlap guarantee — so this makes the dark seam unreachable
 * rather than merely absent. The rendered colour is unchanged where nothing overlaps:
 * group 0.35 over an opaque child at coverage 1 is the same `0.35·src + 0.65·dst`.
 */
export function TextSelectionHighlights({
  rects,
}: {
  rects: ReadonlyArray<{ x: number; y: number; width: number; height: number }>
}) {
  return (
    <div className="absolute inset-0 pointer-events-none" style={{ opacity: 0.35 }}>
      {rects.map((rect, i) => (
        <div
          key={`shape-text-sel-${i}`}
          className="absolute"
          style={{
            left: rect.x,
            top: rect.y,
            width: rect.width,
            height: rect.height,
            backgroundColor: 'rgb(0, 120, 215)',
          }}
        />
      ))}
    </div>
  )
}
